import { useEffect } from "react";
import big_logo_image from "../assets/big-logo.png";
import _axios from "../axios.config";
import { useGetPlacesHooks } from "../hooks/useGetPlacesHooks";

const Splash = ({message}) => {
  // useEffect(() => {
  //   _axios.get("").then((res) => {
  //     console.log(res?.data, res.config?.headers);
  //   });
  // }, []);

  return (
    <main
    style={{background:"rgba(0,0,0,0.3)",zIndex:1000,top:0,left:0}}
    className="full-screen position-fixed overflow-hidden splash-screen  flex-column d-flex align-items-center justify-content-center">
      <div className="splash-loading position-relative d-flex flex-column align-items-center justify-content-center">
        <img
          src={big_logo_image}
          height={300}
          width={300}
          className=" object-fit-contain"
          style={{ aspectRatio: 1 }}
          alt="acitivity-maps-big-logo"
        />
        {message&&<h5 className="m-0 splash-message">{message}</h5>}
      </div>
    </main>
  );
};

export default Splash;
